import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Component, ElementRef, HostListener, Injector, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { FilterBadgeModel, FilterProperty, FilterPropertyType, Operator } from '../../filter';
import { ActionCoPipeModel, BaseQueovalItem, BreadcrumbModel, ParamApplication, QResult, Select } from '../../models';
import { qDragAndDropCallback } from '../../services';
import { PipeCard } from '../models/pipe-action-co.model';
import { PipeColumn, PipeDisplayMode, PipeGeneralPostModel } from '../models/pipe.model';
import { PipeBaseComponent } from '../pipe-base/pipe-base.component';

@Component({
  selector: 'q-comp-pipe-action-co',
  templateUrl: './pipe-action-co.component.html',
  styleUrls: ['./pipe-action-co.component.css', '../pipe-base/pipe-base.component.css']
})
export class PipeActionCoComponent extends PipeBaseComponent implements OnInit {

  constructor(injector: Injector) {
    super(injector);
    this.configParam.routePrefix = 'api/Pipe/ActionCo/'

    this.configParam.filter.modelGroup = 'ACTION_CO_FILTRE';

    this.configParam.columnDefinition.codeBo = 'BO_ACTIONCO';
    this.configParam.columnDefinition.codeProperty = 'Type_EVE';
    this.configParam.columnDefinition.columnFilterGroupe = 'COLPIPEACTIONCO';
    this.configParam.columnDefinition.tablePrefix = 'actionCo';
    this.configParam.columnDefinition.tableName = 'tDOEvenement';
    this.configParam.columnDefinition.columnOrderBy = 'actionCo.DatedEVE ASC, actionCo.DatefEVE ASC';
    
    // GRID => Nom de la custom grid
    this.configParam.gridModel = !this.indParam.CurrentUrl.GetQueryParam('GRID') ? 'ActionCoList' : this.indParam.CurrentUrl.GetQueryParam('GRID');


    this.configParam.quickSearch.show = true;

    this.configParam.quickSearch.data = [
      { titre: `Donneur d'ordre`, mode: 'CLI', tableName: 'TDOClient', propSearchName: 'RaisoCLI', relationNameOrigine: 'REL_BO_CENT_BO_CSOC', isBoPere: false, key: 'cli.Ident' },
      { titre: 'Contact', mode: 'CNT', tableName: 'TDOPersonne', propSearchName: 'NomfaPER', propDisplayName: 'NomfaPER,Pre01PER', relationName: 'REL_BO_CSOC_BO_CONTACT', isBoPere: false, key: 'contact.Ident' },
      { titre: 'N° de devis', mode: 'NumDevis', tableName: 'TDODocument', propSearchName: 'numerDOC', propDisplayName: 'numerDOC,TitreDOC', relationName: 'REL_BO_CSOC_BO_DEVIS', isBoPere: false, key: 'devis.Ident' },
      { titre: 'Tag', mode: 'TAG', relationName: 'REL_BO_ACTIONCO_BO_TAG', key: 'actionCo.ident' },
    ];
  }

  @HostListener('window:click', ['$event'])  
  ClosePopUp(event: any) {
    for (let i = 0; i < this.pipeColumns.length; i++) {
      document.getElementById(`popUp${i}`)?.classList.remove('d-block');
    };
    document.getElementById(`popUp-1`)?.classList.remove('d-block');
  }
  //@ViewChildren('ScrollViewport') viewPorts: QueryList<CdkVirtualScrollViewport>;
  @ViewChild('modalSettingColumn') modalSettingColumn: ElementRef;

  @ViewChild('btnActionCo') btnTemplate: TemplateRef<any>;
  @ViewChild('cardActionCo') cardTemplate: TemplateRef<any>;
  @ViewChild('columnHeaderActionCo') columnHeaderTemplate: TemplateRef<any>;
  @ViewChild('footerActionCo') footerTemplate: TemplateRef<any>;
  modalTemplate: TemplateRef<any>;

  
  @ViewChildren('popUpCreationActionCo') popUpCreationActionCo: QueryList<ElementRef>;

  public showActionCo: boolean;
  public idActionCo: string;
  public idClient: string;
  private _idClient: string

  public type: string = '';
  public mode: string = '';
  private montantCol: any;

  public isPonderation = false;
  public lstModes: Array<Select> = new Array<Select>();


  public openSettingCol() {

    this.currentColumnModel = new ParamApplication();
    this.selectedColumn = new Array<string>();

    this.http.postHttp<QResult<Array<BaseQueovalItem>>>(`${this.indParam.AppParams.apiUrl}${this.configParam.routePrefix}Column/LIST_ALL_COLUMN`, this.configParam.columnDefinition).subscribe(
      (data: QResult<Array<BaseQueovalItem>>) => {
        this.columnList = data.Value;
      });

    this.http.postHttp<QResult<Array<ParamApplication>>>(`${this.indParam.AppParams.apiUrl}${this.configParam.routePrefix}Column/LIST_MODEL_COLUMN`, this.configParam.columnDefinition).subscribe(
      (data: QResult<Array<ParamApplication>>) => {
        this.columnModelList = data.Value;
      });
    this.modalService.open(this.modalSettingColumn, { centered: true, size: 'lg', windowClass: 'qmodalover' });
  }

  protected afterBaseInit() {
    //retire l'option client de la quicksearch si l'on est dans le contexte client 
    if (this.treeveiwParam.filter.toLocaleLowerCase().includes('cli.ident')) {
      const splitedFilter = this.treeveiwParam.filter.split(';');
      for (let i = 0; i < splitedFilter.length; i += 2) {
        if (i + 1 == splitedFilter.length) break;
        if (splitedFilter[i].toLocaleLowerCase() == 'cli.ident') {
          this._idClient = splitedFilter[i + 1];
          this.configParam.quickSearch.data = this.configParam.quickSearch.data.filter(x => x.mode != 'CLI');
          break;
        }
      }
    }

    this.getActionCoModeEve();
  }

  protected cardClickCallBack(data: qDragAndDropCallback) {
    this.type = this.pipeColumns[data.oldColId].columnSelector[0].PropValue;
    this.openActionCo(data.ident, PipeDisplayMode.Pipe);
  }
  protected afterDropCallBack(data: qDragAndDropCallback) {
    this.returnMontantColonne();
  }


  protected getQuickSearchPropKey(mode: string): string {
    let propKey: string = '';
    switch (mode) {
      case 'CLI': propKey = 'client.Ident'; break;
      case 'CNT': propKey = 'contact.Ident'; break;
      default: break;
    }
    return propKey;
  }

  protected gridClickCallBack(res: any) {
    this.openActionCo(res.Value, PipeDisplayMode.Grid);
  }

  private openActionCo(idActionCo: string, displayMode: PipeDisplayMode) {
    this.saveNavigationParam();
    //{ modalContainer: false, idActionCo: idActionCo }
    this.breadcrumb.call(new BreadcrumbModel('add', `view/action-commerciale/carte/${idActionCo}`, null, 'Action commerciale', true, `modalContainer=false&idActionCo=${idActionCo}`), -1, '');
  }

  protected beforeGetCards() {
    const order = this.filterBadges.find(b => b.PropKey == "orderBy")
    this.configParam.columnDefinition.columnOrderBy = order ? order.PropValue : 'actionCo.DatedEVE ASC, actionCo.DatefEVE ASC';
  }

  protected afterGetCardsPipe() {
    this.returnMontantColonne();   
  }
  private returnMontantColonne() {
    let model: PipeGeneralPostModel = new PipeGeneralPostModel();
    model.filterBadges = this.filterBadges;
    this.http.postHttp<QResult<any>>(`${this.indParam.AppParams.apiUrl}${this.configParam.routePrefix}FilteredSpe/RETURN_COLUMN_MONTANT`, model).subscribe((result: QResult<any>) => {
      this.montantCol = result.Value;
      this.pipeColumns.forEach((col: PipeColumn) => {
        if (!this.montantCol[col.columnSelector[0].PropValue]) {
          col.infoSupp = { Montant: 0, MontantPondere: 0 };
        } else {
          col.infoSupp = this.montantCol[col.columnSelector[0].PropValue];
        }
      })
    });
  }
  private getActionCoModeEve() {
    this.http.getHttp<ActionCoPipeModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Pipe/GET_COMBO_LIST/PROP_BO_ACTIONCO_Mode_EVE`).subscribe((res: ActionCoPipeModel) => {
      this.lstModes = res.lstModes;
    })
  }



  public openPopUp(event: MouseEvent, col: PipeColumn | null, colId: number = -1) {
    event.stopPropagation();

    if (this.lstModes.length == 0) {
      this.openCreateActionCo('', col);
      return;
    }

    if (this.lstModes.length === 1) {
      this.openCreateActionCo(this.lstModes[0].id, col);
      return;
    }

    this.popUpCreationActionCo.forEach((e) => e.nativeElement.classList.remove('d-block'));

    const element = this.popUpCreationActionCo.filter((e) => e.nativeElement.id == `popUp${colId}`).map((e) => e.nativeElement)
    if (element[0]) {
      element[0].classList.add('d-block');
    }
  }


  public openCreateActionCo(modeActionCo: string, col: PipeColumn | null) {
    const typeActionCo = col ? col.columnSelector[0].PropValue : '';
    const colId = col ? this.pipeColumns.findIndex(c => { return c.columnSelector = col.columnSelector }) : -1;

    this.showActionCo = false;
    this.idActionCo = '';
    this.type = typeActionCo;
    this.mode = modeActionCo;
    this.idClient = this._idClient;

    this.saveNavigationParam();
    this.breadcrumb.call(new BreadcrumbModel('add', `view/action-commerciale/carte`, null, 'Action commerciale', true), -1, { idActionCo: '', modalContainer: 1, type: typeActionCo, mode: modeActionCo, idClient: this._idClient, showActionCo: false }); 
  }


  protected afterGetCardsGrid(filtredIdent: String[] | undefined = undefined) {
    this.http.postHttp<QResult<any>>(`${this.indParam.AppParams.apiUrl}${this.configParam.routePrefix}InfoAction/INFO_SUPPLEMENTAIRE_GRID`, filtredIdent).subscribe(result => {
      this.gridUpdateValue = result.Value;
    });
  }
}
